/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { useFormik } from 'formik'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import { AlertModal } from '../../../common/components/AlertModal'
import { requestPassword } from '../core/_requests'

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Formato de correo inválido')
    .required('Correo electrónico es requerido'),
})

const initialValues = {
  email: '',
}

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [showMessageModal, setShowMessageModal] = useState(false)
  const navigate = useNavigate()

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        await requestPassword(values.email)
        setShowMessageModal(true)
        formik.resetForm()
      } catch (error: any) {
        setStatus(
          error?.response?.data?.message ||
            'Ha ocurrido un error al enviar el correo. Por favor, intenta nuevamente.'
        )
        setSubmitting(false)
      } finally {
        setLoading(false)
      }
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_forgot_password_form'
    >
      <div className='text-end mb-6'>
        <img src='/media/logos/prudencialsafblue.svg' alt='logo' style={{ maxWidth: '220px' }} />
      </div>

      <div className=' mb-10'>
        <h1 className='mb-3 text-blue-primary fw-bold' style={{ fontSize: '24px' }}>
          ¿Olvidaste la contraseña?
        </h1>
        <div className=' fs-4 text-paragraph'>
          Si tu correo está registrado, se enviará un enlace para iniciar el proceso de recuperación
          de contraseña.
        </div>
      </div>

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>Correo electrónico</label>
        <input
          placeholder='Correo electrónico'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <span className='text-danger' role='alert'>
              {formik.errors.email}
            </span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center text-white'>
        <button
          style={{ maxWidth: '320px' }}
          type='submit'
          id='kt_forgot_password_submit'
          className='btn btn-lg w-100 mb-8 bg-blue-primary text-white '
          disabled={
            formik.isSubmitting || !formik.values.email || !formik.isValid || !!formik.errors.email
          }
        >
          {!loading && <span className='indicator-label'>Confirmar</span>}
          {loading && (
            <span className='indicator-progress d-block'>
              Enviando...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link
          to='/auth/login'
          className='fs-6 fw-bolder m-auto d-block text-blue-primary text-decoration-none mb-4 '
        >
          Ir al inicio de sesión
        </Link>
      </div>
      {/* end::Action */}

      {/* Modal de mensaje - Correo enviado */}
      <AlertModal
        show={showMessageModal}
        onHide={() => {
          setShowMessageModal(false)
        }}
        maxWidth={420}
        icon='message'
        title='Revisa tu bandeja de entrada'
        message='Hemos enviado un correo con un enlace al que debes acceder para cambiar tu contraseña.'
        buttonText='Aceptar'
        fullWidthButton={true}
        onConfirm={() => {
          setShowMessageModal(false)
          navigate('/auth/login')
        }}
      />
    </form>
  )
}
